import { defineComponent as _defineComponent } from 'vue'
import ExportDialog from '@/ui/export-dialog/export-dialog.vue'
import {
    ExportDialogTextContent,
    Format,
    TemplateItem,
    TriggerExportInput
} from '@/ui/export-dialog/export-dialog.types'
import { ref } from 'vue'
import i18n from '@/plugins/i18n'
import { ExportType } from '@/model/export/types'
import { pollExportUrl } from '@/service/export'
import { track } from '@/plugins/tracker'
import { Export, ExportStatus } from '@/graphql/app/types'

interface Props {
    title: string
    type: ExportType
    open: boolean
    cancel: () => void
    templates: Array<TemplateItem>
    formats: Array<Format>
    triggerExport: (input: TriggerExportInput) => Promise<Export | null>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'dialog-with-polling',
  props: {
    title: null,
    type: null,
    open: { type: Boolean },
    cancel: null,
    templates: null,
    formats: null,
    triggerExport: null
  },
  setup(__props: any) {

const props = __props as {
    title: string
    type: ExportType
    open: boolean
    cancel: () => void
    templates: Array<TemplateItem>
    formats: Array<Format>
    triggerExport: (input: TriggerExportInput) => Promise<Export | null>
}



const stopPolling = ref<null |(() => void)>(null)

const textContent = (): ExportDialogTextContent => ({
    exportTitle: i18n.t(`components.exports.title.${props.type}`).toString(),
    item: {
        type: i18n.t(`components.exports.type.${props.type}`).toString(),
        title: props.title
    },
    formatsTitle: i18n.t('components.exports.format.title').toString(),
    templatesTitle: i18n.t('components.exports.template.title').toString(),
    button: {
        triggerExport: i18n.t('components.exports.actions.export').toString(),
        downloadExport: i18n.t('components.exports.actions.download').toString()
    },
    error: i18n.t('components.exports.format.error').toString()
})

async function runExport (input: TriggerExportInput) {
    const result = await props.triggerExport(input)

    if (result?.status === ExportStatus.Ready && result?.url) {
        return result.url
    }

    if (result?.id) {
        const { start, stop } = pollExportUrl(result.id)
        stopPolling.value = stop

        return await start()
    }

    throw new Error('Export failed')
}

function handleCancel () {
    if (stopPolling.value !== null) {
        stopPolling.value()
    }
    props.cancel()
}

function trackExport (format: Format) {
    track(props.type, 'export', format)
}


return { __sfc: true,props, stopPolling, textContent, runExport, handleCancel, trackExport, ExportDialog }
}

})